import classNames from 'classnames';
import { differenceInDays } from 'date-fns/differenceInDays';
import { formatDistanceToNowStrict } from 'date-fns/formatDistanceToNowStrict';
import { parseISO } from 'date-fns/parseISO';
import isString from 'lodash-es/isString';
import { useIntl } from 'react-intl';

import dateLocale from '../../lib/dateLocale';

import DurationTypo from '../typography/Duration';

import styles from '../../styles/partials/time.module.css';

type MonthOption = Intl.DateTimeFormatOptions['month'];
type DayOption = Intl.DateTimeFormatOptions['day'];
type YearOption = Intl.DateTimeFormatOptions['year'];
type WeekdayOption = Intl.DateTimeFormatOptions['weekday'];

interface TimeProps {
    date: string | Date;
    textOnly?: boolean;
    withoutRelative?: boolean;
    month?: MonthOption;
    day?: DayOption;
    year?: YearOption;
    weekday?: WeekdayOption;
    timeOnly?: boolean;
    className?: string | null;
}

function Time({
    date,
    month = 'short',
    day = 'numeric',
    year = 'numeric',
    weekday = undefined,
    textOnly = false,
    timeOnly = false,
    withoutRelative = false,
    className = null,
}: TimeProps) {
    const intl = useIntl();

    let time = null;
    const now = new Date();
    const dateObj = isString(date) ? parseISO(date) : date;

    const days = differenceInDays(now, dateObj);
    const formatMethod = timeOnly ? 'formatTime' : 'formatDate';

    if (days === 1 && !withoutRelative && !timeOnly) {
        time = intl.formatMessage({
            defaultMessage: 'Hier',
            description: 'Time label',
        });
    } else if (now.getFullYear() !== dateObj.getFullYear()) {
        time = intl[formatMethod](
            dateObj,
            !timeOnly
                ? {}
                : {
                      weekday,
                      month,
                      day,
                      year,
                  },
        );
    } else {
        time =
            (days >= 2 && !timeOnly) || (days >= 1 && timeOnly) || withoutRelative
                ? intl[formatMethod](
                      dateObj,
                      !timeOnly
                          ? {
                                weekday,
                                month,
                                day,
                            }
                          : {},
                  )
                : formatDistanceToNowStrict(dateObj, { locale: dateLocale, addSuffix: true });
    }

    return textOnly ? (
        time
    ) : (
        <DurationTypo
            className={classNames([styles.container, className])}
            suppressHydrationWarning={true}
        >
            {time}
        </DurationTypo>
    );
}

export default Time;
